<script>
    import Button from "../../Components/Common/Button.svelte";
    import Input from "./components/SigninInput.svelte";

    import { goToURL } from "../../Utils/utilFunctions.svelte";
    import { apiMethods } from "../../Services/index.svelte";

    let email,
        isSubmittingEmail = false,
        isEmailSubmitted = false,
        error;

    $: isSubmitDisabled = !email;

    const submitEmail = () => {
        isSubmittingEmail = true;
        apiMethods.postMethod
            .forgetPwd({ email })
            .then((res) => {
                isSubmittingEmail = false;
                isEmailSubmitted = true;
            })
            .catch((err) => console.log(err));
    };

    const goToSignIn = () => {
        goToURL("/");
    };

    const clearError = () => {
        error = null;
    };
</script>

<div class="flex-1 flex flex-col items-center w-full h-full p-6 showBG">
    <div class="flex items-center px-4 py-2">
        <img src="/favicon.png" alt="" class="w-[48px] h-[48px]" />
        <p class="text-primary text-2xl font-bold title-font pl-4">Anaemate</p>
    </div>

    <div class="flex flex-1 items-center justify-evenly w-full">
        <div class="artboard artboard-demo w-auto h-auto gap-4 p-6 shadow-lg">
            {#if !isEmailSubmitted}
                <div class="flex flex-col items-center">
                    <p class="text-[24px] font-bold text-gray-600">
                        Forgot Password ?
                    </p>
                    <p class="font-medium text-[16px] text-primary">
                        <span>Already have an account?</span>
                        <span> Enter your email to reset your password </span>
                    </p>
                </div>
                <form novalidate>
                    <Input
                        label="Email"
                        bind:value={email}
                        type="email"
                        inputClass="w-80"
                        autofocus
                        {error}
                        {clearError}
                    />

                    <div
                        class="flex flex-1 flex-row-reverse items-center justify-between"
                    >
                        <Button
                            manualClass={`min-w-[130px] btn-primary ${
                                isSubmittingEmail ? "loading" : ""
                            }`}
                            clickFunc={submitEmail}
                            isDisabled={isSubmittingEmail || isSubmitDisabled}
                        >
                            {isSubmittingEmail ? "Submitting" : "Submit"}
                        </Button>

                        <Button
                            manualClass="min-w-[130px] btn-error"
                            clickFunc={goToSignIn}
                            isDisabled={isSubmittingEmail}
                        >
                            Cancel
                        </Button>
                    </div>
                </form>
            {:else}
                <div class="flex flex-col items-center">
                    <p class="text-[24px] font-bold text-gray-600">
                        Email send to {email}
                    </p>
                    <p class="font-medium text-[16px] text-primary">
                        Please check your email address to complete further
                        steps
                    </p>
                </div>

                <Button
                    manualClass="min-w-[130px] btn-primary"
                    clickFunc={goToSignIn}
                >
                    OK
                </Button>
            {/if}
        </div>
    </div>
</div>

<style>
    .artboard {
        background-color: #f7f7f7;
        border: 1px solid rgba(65, 91, 63, 0.25);
        box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
        border-radius: 15px;
    }

    .showBG {
        height: 100vh;
        background-image: url("/imgs/bg_signIn.png");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: bottom;
        background-size: contain;
    }
</style>
